var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 11.6668V11.6668C3.24583 11.6668 2.5 10.921 2.5 10.0002V10.0002C2.5 9.07933 3.24583 8.3335 4.16667 8.3335V8.3335C5.0875 8.3335 5.83333 9.07933 5.83333 10.0002V10.0002C5.83333 10.921 5.0875 11.6668 4.16667 11.6668Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.6668V11.6668C9.07918 11.6668 8.33334 10.921 8.33334 10.0002V10.0002C8.33334 9.07933 9.07918 8.3335 10 8.3335V8.3335C10.9208 8.3335 11.6667 9.07933 11.6667 10.0002V10.0002C11.6667 10.921 10.9208 11.6668 10 11.6668Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 11.6668V11.6668C14.9125 11.6668 14.1667 10.921 14.1667 10.0002V10.0002C14.1667 9.07933 14.9125 8.3335 15.8333 8.3335V8.3335C16.7542 8.3335 17.5 9.07933 17.5 10.0002V10.0002C17.5 10.921 16.7542 11.6668 15.8333 11.6668Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 17.4998V17.4998C3.24583 17.4998 2.5 16.754 2.5 15.8332V15.8332C2.5 14.9123 3.24583 14.1665 4.16667 14.1665V14.1665C5.0875 14.1665 5.83333 14.9123 5.83333 15.8332V15.8332C5.83333 16.754 5.0875 17.4998 4.16667 17.4998Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.4998V17.4998C9.07918 17.4998 8.33334 16.754 8.33334 15.8332V15.8332C8.33334 14.9123 9.07918 14.1665 10 14.1665V14.1665C10.9208 14.1665 11.6667 14.9123 11.6667 15.8332V15.8332C11.6667 16.754 10.9208 17.4998 10 17.4998Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 17.4998V17.4998C14.9125 17.4998 14.1667 16.754 14.1667 15.8332V15.8332C14.1667 14.9123 14.9125 14.1665 15.8333 14.1665V14.1665C16.7542 14.1665 17.5 14.9123 17.5 15.8332V15.8332C17.5 16.754 16.7542 17.4998 15.8333 17.4998Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 5.83333V5.83333C3.24583 5.83333 2.5 5.0875 2.5 4.16667V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5V2.5C5.0875 2.5 5.83333 3.24583 5.83333 4.16667V4.16667C5.83333 5.0875 5.0875 5.83333 4.16667 5.83333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.83333V5.83333C9.07918 5.83333 8.33334 5.0875 8.33334 4.16667V4.16667C8.33334 3.24583 9.07918 2.5 10 2.5V2.5C10.9208 2.5 11.6667 3.24583 11.6667 4.16667V4.16667C11.6667 5.0875 10.9208 5.83333 10 5.83333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 5.83333C14.9125 5.83333 14.1667 5.0875 14.1667 4.16667C14.1667 3.24583 14.9125 2.5 15.8333 2.5C16.7542 2.5 17.5 3.24583 17.5 4.16667C17.5 5.0875 16.7542 5.83333 15.8333 5.83333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export default ForwardRef;